export const NOT_SET = 'Значение не задано'